import { Button, Card, Col, Icons, Row, Tooltip, Typography } from '@pankod/refine-antd';
import { IReportDashboard } from 'interfaces';
import { useEffect, useState } from 'react';
import { getDashboardReportsInfo } from 'services/report';
import { formatCurrency } from 'utilities/shared';

const { Title, Text } = Typography;

type ReportsDashboardProps = {
  date: {
    startDate: string;
    endDate: string;
    tagIds?: string[];
    categoryId?: string;
  };
};

export const ReportsDashboard: React.FC<ReportsDashboardProps> = (props) => {
  const [reports, setReports] = useState<IReportDashboard>({} as IReportDashboard);

  useEffect(() => {
    (async () => {
      try {
        const data = await getDashboardReportsInfo(props.date);
        setReports(data);
      } catch (err) {
        setReports({} as IReportDashboard);
      }
    })();
  }, [props.date]);

  return (
    <Row gutter={[16, 16]} style={{ marginBottom: '3rem' }}>
      <Col lg={6} md={12}>
        <div
          style={{
            position: 'relative',
          }}
        >
          <InfoCard name="Profit/Loss (Gross)" amount={reports.grossProfit} />
          <div
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
            }}
          >
            <Tooltip title={<span>Total Sales - Total Purchases - Total Returns</span>}>
              <Button size="small" icon={<Icons.InfoOutlined />} />
            </Tooltip>
          </div>
        </div>
      </Col>
      {reports.netProfit !== null && reports.netProfit !== undefined && (
        <Col lg={6} md={12}>
          <InfoCard name="Profit/Loss (Net)" amount={reports.netProfit} />
        </Col>
      )}
      <Col lg={6} md={12}>
        <InfoCard name="Total Purchase" amount={reports.purchase} />
      </Col>
      <Col lg={6} md={12}>
        <InfoCard name="Total Sales" amount={reports.sales} />
      </Col>
      <Col lg={6} md={12}>
        <InfoCard name="Discount" amount={reports.discount} />
      </Col>
      <Col lg={6} md={12}>
        <InfoCard name="Expenses" amount={reports.expense} />
      </Col>
      <Col lg={6} md={12}>
        <InfoCard name="Return" amount={reports.return} />
      </Col>
      <Col lg={6} md={12}>
        <InfoCard name="Damage" amount={reports.damage} />
      </Col>
    </Row>
  );
};

type InfoCardProps = {
  name: string;
  amount: number;
};

const InfoCard: React.FC<InfoCardProps> = (props) => {
  return (
    <Card>
      <div
        style={{
          width: '100%',
          height: '60px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div>
          <Title level={5} style={{ marginBottom: '0px' }}>
            {props.name}
          </Title>
          <Text strong style={{ fontSize: '24px' }}>
            <span style={{ fontWeight: 'bolder' }}>TK</span>
            {formatCurrency(props.amount)}
          </Text>
        </div>
      </div>
    </Card>
  );
};
